import React, {Component} from 'react'
import { connect } from "react-redux";
import MyTable from "../../../components/TableComponents/Table";
import {setHcpDataSelection,editHCP, setHcpLockedStatus,filterHcpTable} from "../../../redux/actions/Tabs-Actions";
import HcpEditForm from "../../../components/hcp/HCPEditForm";
import {adminApi} from "../../../services/ApiService";
import SvGraphics from "../../../assets/SvGraphics";
import AlertConfirm from "../../../components/modals/Confirm";
import Constants from "../../../utils/constants";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {ConstantsArrT} from "../../../utils/ConstantsWithTranslate";

class HCPsTabConnComposed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isSideBarOpen: false,
            entry: null
        }
    }

    async openSideBar(hcp){
        await this.setState({entry:hcp,isSideBarOpen:true})
        document.body.style.overflow = "hidden"
        this.forceUpdate();
    }


    componentWillUnmount() {

    }

    onSelectionChange = (selected) => {
        this.props.setHcpDataSelection(selected)
    }



    editHcpDetails = async (hcp) => {
        await this.openSideBar(hcp)
    }

    lockHcp = async (hcp) => {
        let {t} = this.props
        let confirm = await AlertConfirm({
            options:{
                title: t('admin.hcp.table.lock_hcp'),
            }},`${t('admin.hcp.table.lock_hcp_confirm')}: ${hcp.FullName}?`)
        if (confirm){
            let data = {'Enabled':0}
            let response = await adminApi.EditHCP(data,hcp.UserStorageID)
            if (response){
                await this.props.setHcpLockedStatus(response.data)
            }
        }
    }

    unlockHcp = async (hcp) => {
        let {t} = this.props
        let confirm = await AlertConfirm({
            options:{
                title: t('admin.hcp.table.unlock_hcp'),
            }},`${t('admin.hcp.table.unlock_hcp_confirm')}: ${hcp.FullName}?`)
        if (confirm) {
            let data = {'Enabled':1}
            let response = await adminApi.EditHCP(data,hcp.UserStorageID)
            if (response){
                await this.props.setHcpLockedStatus(response.data)
            }
        }
    }

    setHcpMoreFunctions = () => {
        let {t} = this.props
        return [
            {
                name: 'Edit HCP details',
                display: t('admin.hcp.table.edit_hcp_details'),
                call: (id => this.editHcpDetails(id))
            },
            {
                name: 'Lock HCP',
                display: t('admin.hcp.table.lock_hcp'),
                call: (id => this.lockHcp(id))
            },
            {
                name: 'Unlock HCP',
                display: t('admin.hcp.table.unlock_hcp'),
                call: (id => this.unlockHcp(id))
            }
        ]
    }

    onFilterDataSelected = (filter) => {
        this.props.filterHcpTable(Object.keys(filter)[0],Object.values(filter)[0])
    }

    getColumns = (t) => {
        return [
            {accessor: 'First_name', Header: t('admin.hcp.table.first_name'), resizable: false},
            {accessor: 'Last_name', Header: t('admin.hcp.table.last_name'), resizable: false},
            {accessor: 'Email', Header: t('admin.hcp.table.username'), resizable: false},
            {accessor: 'ProfessionLabel', Header: t('admin.hcp.table.profession'), resizable: false,Cell: ({ original }) => {
                    return t(original.ProfessionLabel)
                }},
            {accessor: 'isClinicAdmin', Header: t('admin.hcp.table.is_admin'), resizable: false,Cell: ({ original }) => {
                return original.isClinicAdmin ? <SvGraphics svgname={'true'} style={{height:'15px',width:'15px', marginLeft: '19px'}}/> : ''
            }},
            {accessor: 'Clinic_Name', Header: t('admin.hcp.table.clinic_name'), resizable: false,makeFilter: true},
            {accessor: 'Enabled', Header: t('admin.hcp.table.locked'), resizable: false,Cell: ({ original }) => {
                    if (original.Enabled){
                        return ''
                    } return (<SvGraphics svgname={'true'} style={{height:'15px',width:'15px', marginLeft: '19px'}}/>)
                }, makeFilter: true, filterConverter: ConstantsArrT(t,Constants.locked)}
        ]
    }

    render() {
        let {t} = this.props
        let {entry,isSideBarOpen} = this.state
        let columns = this.getColumns(t)
        return (
            <div className={'context-area'}>
                <MyTable
                    data={this.props.hcpData}
                    columns={columns}
                    initialData={this.props.initiateHcpData}
                    onSelectionChange={selected => this.onSelectionChange(selected)}
                    moreFunctions={this.setHcpMoreFunctions()}
                    onFilterDataSelected={filter => this.onFilterDataSelected(filter)}
                    hasSelection={true}
                    hasMore={true}
                    hasShowInfo={false}
                />
                {isSideBarOpen && <HcpEditForm
                    t={e => t(e)}
                    title={t('admin.hcp.form.edit_hcp')}
                    entry={entry}
                    editHCP={hcpData => this.props.editHCP(hcpData)}
                    isSideBarOpen={isSideBarOpen}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}
            </div>

        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setHcpLockedStatus: hcpData => dispatch(setHcpLockedStatus(hcpData)),
        editHCP: hcpData => dispatch(editHCP(hcpData)),
        setHcpDataSelection: hcpData => dispatch(setHcpDataSelection(hcpData)),
        filterHcpTable: (type,payload) => dispatch(filterHcpTable(type,payload)),
    };
}

const mapStateToProps = state => {
    return {
        hcpData:state.hcpTableDataReducer.hcpData,
        initiateHcpData:state.hcpTableDataReducer.initiateHcpData
    };
};

const HCPsTab = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(HCPsTabConnComposed);

export default HCPsTab;
